import { MapStore } from './stores/map-store';
import { Cookie, CookieAdapter, CookieOptions } from './stores/adapters/cookie-adapter';

export const defaultOptions: CookieOptions = Object.freeze({
    // 400 days is the maximum allowed by the browser
    domain: `.${document.location.hostname}`,
    maxAge: 400 * 60 * 60 * 24,
    secure: false,
    path: '/',
    sameSite: 'none'
});

const store = new MapStore(new CookieAdapter());

export const getCookie = (name: string): Cookie => store?.get(name);

export const hasCookie = (name: string): boolean => store.has(name);

export const getCookies = () => store.getAll();

export const deleteCookie = (name: string): void => store.delete(name);

export const setCookie = (name: string, value: string, options: CookieOptions = defaultOptions) =>
    store.set(name, { value, options: { ...defaultOptions, ...options } });
